import { render, staticRenderFns } from "./DataSourceSettings.vue?vue&type=template&id=f9095a86&scoped=true&"
import script from "./DataSourceSettings.vue?vue&type=script&lang=js&"
export * from "./DataSourceSettings.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceSettings.vue?vue&type=style&index=0&id=f9095a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9095a86",
  null
  
)

export default component.exports